import React from "react"
import { useSelector, useDispatch } from "react-redux"
import { Row, Col } from "react-bootstrap"

import { VIEW, EDIT, OPEN } from "const"
import { hasAccess } from "client/utils"
import { okrKeyResultsRoute } from "client/parts/routes"
import {
    PRM_OKR_OBJECTIVE_KEY_RESULT,
    OkrObjectiveObjectProps,
    StoreType,
    IsOwnerOkrObjective,
    addModal,
} from "client/store"
import {
    FormGroup,
    Label,
    Input,
    DivInput,
    Link,
    Empty,
    Textarea,
    UserIcon,
    TagEditor,
    Button,
} from "client/components"
import {
    ObjectiveForm,
    OwnerList,
} from "client/pages/okr/styled"

const Form = ({
    objective,
}: OkrObjectiveObjectProps) => {
    const session = useSelector((state: StoreType) => state.okrSession.sessionView)
    const objectiveBaseRoute = useSelector((state: StoreType) => state.okrObjective.baseRoute)
    const objectiveRoute = useSelector((state: StoreType) => state.okrObjective.objectiveRoute)

    const userList = useSelector((state: StoreType) => state.user.userList)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const isOwnerObjective = IsOwnerOkrObjective(objective, userData.userId)
    const isOwnerSession = session.owner === userData.userId
    const isOwner = isOwnerObjective || isOwnerSession

    const isOpenSession = session.status === OPEN

    const editAccess = hasAccess(PRM_OKR_OBJECTIVE_KEY_RESULT, EDIT)
    const allowedToEdit = (editAccess || isOwner) && isOpenSession

    const baseRoute = `${objectiveBaseRoute}${objectiveRoute}`
    const editUrl = `${baseRoute}/${EDIT}/${objective.id}`
    const parentObjectiveHref = objective.objective ? `${baseRoute}/${VIEW}/${objective.objective.id}` : ""
    const parentKeyResultHref = objective.keyResult
        ? `${baseRoute}/${VIEW}/${objective.keyResult.objectiveId}${okrKeyResultsRoute}/${VIEW}/${objective.keyResult.id}`
        : ""

    const selectedTags: number[] = []
    if (objective && objective.tags) {
        objective.tags.forEach((row) => {
            selectedTags.push(row.tagId)
        })
    }

    return (
        <ObjectiveForm>
            <Row>
                <Col xs={12}>
                    <FormGroup>
                        <Label>{lang.session}</Label>
                        <Input type="text" value={objective.session ? objective.session.name : ""} readOnly />
                    </FormGroup>
                    {
                        objective.objective && (
                            <FormGroup>
                                <Label>{lang.parentObjective}</Label>
                                <DivInput widePadding>
                                    <Link
                                        href={parentObjectiveHref}
                                        onClick={() => dispatch(addModal({ url: parentObjectiveHref }))}
                                    >
                                        {objective.objective.title}
                                    </Link>
                                </DivInput>
                            </FormGroup>
                        )
                    }
                    {
                        objective.keyResult && (
                            <FormGroup>
                                <Label>{lang.parentKeyResult}</Label>
                                <DivInput widePadding>
                                    <Link
                                        href={parentKeyResultHref}
                                        onClick={() => dispatch(addModal({ url: parentKeyResultHref }))}
                                    >
                                        {objective.keyResult.title}
                                    </Link>
                                </DivInput>
                            </FormGroup>
                        )
                    }
                    {
                        !objective.objective && !objective.keyResult && (
                            <FormGroup>
                                <Label>{lang.parent}</Label>
                                <DivInput widePadding><Empty /></DivInput>
                            </FormGroup>
                        )
                    }
                    <FormGroup>
                        <Label>{lang.description}</Label>
                        <Textarea value={objective.description} readOnly />
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.owners}</Label>
                        <OwnerList>
                            {
                                objective.owners && objective.owners.map((row) => (
                                    <UserIcon key={row.userId} user={userList[row.userId]} size="sm" />
                                ))
                            }
                        </OwnerList>
                    </FormGroup>
                    <FormGroup>
                        <Label>{lang.tags}</Label>
                        <TagEditor
                            selectedIds={selectedTags}
                            readOnly
                        />
                    </FormGroup>
                </Col>
                <Col xs={12}>
                    {
                        allowedToEdit && (
                            <Button onClick={() => dispatch(addModal({ url: editUrl }))}>
                                {lang.edit}
                            </Button>
                        )
                    }
                </Col>
            </Row>
        </ObjectiveForm>
    )
}
export default Form
